"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionModal = void 0;
var react_1 = __importDefault(require("react"));
var react_loader_spinner_1 = require("react-loader-spinner");
var react_modal_1 = __importDefault(require("react-modal"));
var use_contractkit_1 = require("../use-contractkit");
var styles_1 = require("./styles");
var defaultActionModalComponent = function (_a) {
    var dappName = _a.dappName, pendingActionCount = _a.pendingActionCount;
    return (react_1.default.createElement("div", { className: "tw-px-5 tw-py-6" },
        react_1.default.createElement("div", { className: "tw-text-xl tw-text-center tw-text-gray-800 dark:tw-text-gray-200 tw-mb-4" }, "Check your wallet"),
        react_1.default.createElement("p", { className: "tw-text-gray-700 dark:tw-text-gray-400 tw-text-sm tw-text-center" },
            dappName,
            " is trying to",
            ' ',
            pendingActionCount > 1
                ? "perform ".concat(pendingActionCount, " actions")
                : 'perform an action',
            ". Please check your wallet to confirm."),
        react_1.default.createElement("div", { className: "tw-my-8 tw-flex tw-items-center tw-justify-center" },
            react_1.default.createElement(react_loader_spinner_1.TailSpin, { color: "#666666", height: "60px", width: "60px" }))));
};
var ActionModal = function (_a) {
    var reactModalProps = _a.reactModalProps, _b = _a.render, render = _b === void 0 ? defaultActionModalComponent : _b;
    var _c = (0, use_contractkit_1.useContractKitInternal)(), pendingActionCount = _c.pendingActionCount, dapp = _c.dapp;
    return (react_1.default.createElement(react_modal_1.default, __assign({ isOpen: pendingActionCount > 0, ariaHideApp: false }, (reactModalProps
        ? reactModalProps
        : {
            style: styles_1.defaultModalStyles,
            overlayClassName: 'tw-fixed tw-bg-gray-100 dark:tw-bg-gray-700 tw-bg-opacity-75 tw-inset-0',
        })),
        react_1.default.createElement("div", { className: "use-ck tw-max-h-screen" },
            react_1.default.createElement("div", { className: "tw-relative tw-bg-white dark:tw-bg-gray-800 tw-w-80 md:tw-w-96" }, render({ dappName: dapp.name, pendingActionCount: pendingActionCount })))));
};
exports.ActionModal = ActionModal;
//# sourceMappingURL=action.js.map